import { render, staticRenderFns } from "./PollsShort.vue?vue&type=template&id=694c16ba&"
import script from "./PollsShort.vue?vue&type=script&lang=js&"
export * from "./PollsShort.vue?vue&type=script&lang=js&"
import style0 from "./PollsShort.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PollsShort.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports